<template>
  <v-card v-if="items?.length > 0" :disabled="loading" flat class="pa-4">
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="cyan"
      class="pa-0"
    ></v-progress-linear>
    <v-stepper
      class="pa-0"
      style="background: transparent"
      color="transparent"
      v-model="e6"
      flat
    >
      <v-stepper-items>
        <v-stepper-content class="pa-0" step="1">
          <v-card-title v-if="value?.title" :style="{ color: colorComputed }"
            >{{ value?.title }}
          </v-card-title>
          <v-card-subtitle
            v-if="value.description"
            :style="{ color: colorComputed }"
            >{{ value?.description }}</v-card-subtitle
          >
          <v-row class="pa-2">
            <v-col
              class="pa-1"
              cols="12"
              md="6"
              v-for="(form, index) in items.filter(
                (item) => item.items[0].type != 'textarea'
              )"
              :key="form.id"
            >
              <v-text-field
                :label="form.items[0].optional ? `${form.label}*` : form.label"
                :error="errorHandler[form.id] ?? null"
                v-model="form.feedAction"
                :background-color="colorComputed"
                outlined
                :error-messages="
                  form?.items[0]?.setting?.max || form?.items[0]?.setting?.min
                    ? hintHandler(
                        form?.items[0]?.setting.min,
                        form?.items[0]?.setting.max,
                        form.feedAction
                      )
                    : null
                "
                dense
                :counter="form?.items[0]?.setting?.max ?? undefined"
                type="text"
                v-if="form.items[0].type == 'text'"
                :append-icon="form.action"
                :rules="[
                  (v) =>
                    rules(v, form?.items[0]?.setting?.regex?.value)?.test ||
                    v == null ||
                    rules(v, form?.items[0]?.setting?.regex?.value).text,
                ]"
              />
              <v-text-field
                :label="form.items[0].optional ? `${form.label}*` : form.label"
                :error="errorHandler[form.id] ?? null"
                :background-color="colorComputed"
                :counter="form?.items[0]?.setting?.max ?? undefined"
                :append-icon="form.action"
                v-model="form.feedAction"
                :error-messages="
                  form?.items[0]?.setting?.max || form?.items[0]?.setting?.min
                    ? hintHandler(
                        form?.items[0]?.setting.min,
                        form?.items[0]?.setting.max,
                        form.feedAction
                      )
                    : null
                "
                outlined
                dense
                type="number"
                v-else-if="form.items[0].type == 'number'"
                :rules="[
                  (v) =>
                    rules(v, form?.items[0]?.setting?.regex?.value)?.test ||
                    v == null ||
                    rules(v, form?.items[0]?.setting?.regex?.value).text,
                ]"
              />

              <v-combobox
                v-model="form.feedAction"
                :append-icon="form.action"
                :error="errorHandler[form.id] ?? null"
                outlined
                :label="form.items[0].optional ? `${form.label}*` : form.label"
                :placeholder="form.items[0].label ?? $t('select')"
                dense
                v-else-if="form.items[0].type == 'select'"
                :items="form.items[0].selectItems"
                :background-color="colorComputed"
              />

              <custom-date-picker
                backgroundColor="white"
                v-else-if="form.items[0].type == 'date'"
                :error="errorHandler[form.id] ?? null"
                v-model="form.feedAction"
                :label="form.items[0].optional ? `${form.label}*` : form.label"
                outlined
                dense
                append-icon="mdi-calendar-month"
              />
            </v-col>

            <v-col
              class="pa-1"
              v-for="(form, index) in items"
              v-if="form.items[0].type == 'textarea'"
              :key="form.id"
              :cols="12"
              :md="index % 2 ? 6 : 12"
            >
              <v-textarea
                :error="errorHandler[form.id] ?? null"
                :color="errorHandler[form.id] ? 'red' : colorComputed"
                :background-color="colorComputed"
                :counter="form?.items[0]?.setting?.max ?? undefined"
                :append-icon="form.action"
                v-model="form.feedAction"
                :error-messages="
                  form?.items[0]?.setting?.max || form?.items[0]?.setting?.min
                    ? hintHandler(
                        form?.items[0]?.setting.min,
                        form?.items[0]?.setting.max,
                        form.feedAction
                      )
                    : null
                "
                outlined
                :label="form.items[0].optional ? `${form.label}*` : form.label"
                dense
                :rows="index % 2 ? 1 : 4"
                v-if="form.items[0].type == 'textarea'"
                :rules="[
                  (v) =>
                    rules(v, form?.items[0]?.setting?.regex?.value)?.test ||
                    v == null ||
                    rules(v, form?.items[0]?.setting?.regex?.value).text,
                ]"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-card-actions
            class="my-2 d-flex align-items-center justify-content-end"
          >
            <v-btn
              @click="
                value.conform ? (emptyCheck() ? (e6 = 2) : null) : beforeSend()
              "
              elevation="0"
              :loading="loading"
              class="white--text"
              color="green"
            >
              {{ value.conform ? $t("continue") : $t("SUBMIT_FORM") }}
              <v-icon>
                {{ value.conform ? "mdi-menu-left" : "mdi-book-check" }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content class="pa-0" :step="value.conform ? '2' : '4'">
          <v-card
            color="transparent"
            class="pa-0 d-flex flex-column justify-content-center align-items-center w-100"
            flat
          >
            <v-card-title :style="{ color: colorComputed }">{{
              $t("enter_phone_number")
            }}</v-card-title>
            <v-text-field
              :background-color="colorComputed"
              outlined
              type="number"
              dense
              v-model="conformNumber"
              :rules="[
                (v) =>
                  !!v ||
                  v == null ||
                  rules(v, 'mobile').test ||
                  rules(v, 'mobile').text,
              ]"
            />

            <v-card-actions
              class="d-flex justify-content-around align-items-center"
            >
              <v-btn
                elevation="0"
                @click="e6 = 1"
                class="white--text"
                color="red"
              >
                <v-icon>mdi-menu-right</v-icon>
                {{ $t("back") }}
              </v-btn>
              <v-btn
                elevation="0"
                :disabled="!rules(conformNumber, 'mobile').test"
                class="white--text"
                color="green"
                @click="e6 = 3"
              >
                {{ $t("continue") }}
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="pa-0">
          <v-card
            class="pa-0 d-flex flex-column justify-content-center align-items-center w-100"
            flat
            color="transparent"
          >
            <v-card-subtitle :style="{ color: colorComputed }">{{
              $t("Enter_the_sent_code")
            }}</v-card-subtitle>
            <v-card
              flat
              color="transparent"
              class="pa-0 d-flex justify-content-center"
              max-width="300px"
              dir="ltr"
            >
              <v-otp-input
                :length="4"
                dir="ltr"
                v-model="otp"
                :disabled="loading"
              ></v-otp-input>
            </v-card>

            <v-card-actions class="d-flex justify-content-start">
              <v-btn
                elevation="0"
                @click="e6 = 2"
                class="white--text"
                color="red"
              >
                <v-icon>mdi-menu-right</v-icon>
                {{ $t("back") }}
              </v-btn>
              <v-btn
                elevation="0"
                :disabled="otp.toString().length != 4"
                class="white--text"
                color="green"
                @click="otpHandler"
              >
                {{ $t("Confirm_code") }}
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content :step="value.conform ? '4' : '2'">
          <v-card flat class="pa-2 text-center" color="transparent">
            <v-card-title
              class="d-flex justify-content-center pa-0"
              :style="{ color: colorComputed }"
              >{{ $t("form_success_message") }}</v-card-title
            >

            <v-card-actions class="d-flex justify-content-center">
              <v-btn
                :loading="loading"
                class="white--text"
                @click="
                  e6 = 1;
                  fetch();
                "
                color="orange"
              >
                <v-icon>mdi-plus</v-icon>
                {{ $t("refill_form_message") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import customDatePicker from "../../../core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";

export default {
  components: { customDatePicker },
  props: {
    value: Object,
    color: String,
  },
  data() {
    return {
      items: [],
      otp: "",
      errorHandler: {},
      loading: false,
      e6: 1,
      regex: {
        persian: /^[\u0600-\u06FF\s]+$/,
        number: /^\d+$/,
        english: /^[a-zA-Z\s]+$/,
        mixPerEng: /^[a-zA-Z0-9\u0600-\u06FF\s]+$/,
        email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        mobile: /^09\d{9}$/,
        meliCode: /^\d{10}$/,
        site: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])?$/,
      },

      conformNumber: null,
      formId: null,
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      let QRID = this.qr_id;
      this.loading = true;
      this.$api
        .get(`application/forms/answer?qr_id=${QRID}`)
        .then(({ data }) => {
          if (!data?.data?.data || !Array.isArray(data?.data?.data)) {
            return;
          }

          let action = data.data.data.filter((item) => item.items[0].action);
          data.data.data.map(
            (item) =>
              (this.errorHandler = { ...this.errorHandler, [item.id]: false })
          );

          this.formId = data.data.id;

          this.items = action;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },

    rules(v, type) {
      let regex = this.regex;

      switch (type) {
        case "persian":
          return { test: regex[type].test(v), text: this.$t("persian_error") };
        case "number":
          return { test: regex[type].test(v), text: this.$t("number_error") };
        case "english":
          return { test: regex[type].test(v), text: this.$t("english_error") };
        case "mixPerEng":
          return {
            test: regex[type].test(v),
            text: this.$t("mixPerEng_error"),
          };
        case "email":
          return { test: regex[type].test(v), text: this.$t("email_error") };
        case "mobile":
          return { test: regex[type].test(v), text: this.$t("mobile_error") };
        case "meliCode":
          return { test: regex[type].test(v), text: this.$t("meliCode_error") };
        case "site":
          return { test: regex[type].test(v), text: this.$t("site_error") };
        default:
          return {
            test: false,
            text: this.$t("default_error", {
              ns: "translation",
              defaultValue: "Unknown error",
            }),
          };
      }
    },

    hintHandler(min, max, val) {
      let leng = typeof val === "string" ? val?.length : val;

      let message = null;
      if (min !== undefined && leng < min) {
        message = this.$t("min_length_error", { min });
      }

      if (max !== undefined && leng > max) {
        message = this.$t("max_length_error", { max });
      }

      return message;
    },

    otpHandler() {
      console.log(this.otp);
    },

    beforeSend() {
      let readInputCheck = this.emptyCheck();
      let awnsers = {};

      if (readInputCheck) {
        this.items.map((item) => {
          item.feedAction?.length > 0
            ? (awnsers = { ...awnsers, [item.title]: item.feedAction })
            : null;
        });

        this.sendData(awnsers);
        console.log(awnsers);
      }
    },

    sendData(val) {
      this.loading = true;
      try {
        this.$api
          .post("/application/forms/answer/store", {
            form_id: this.formId,
            answer: val,
          })
          .then((data) => {
            this.$toast.success(this.$t("form_submitted_message"));
            this.e6 += 1;
          })
          .finally(() => (this.loading = false));
      } catch {}
    },

    emptyCheck() {
      let readInputCheck = true;
      this.items.forEach((item) => {
        const isOptional = item.items[0]?.optional;
        const hasFeedAction = item.feedAction?.length > 0;

        const isValid = !isOptional || hasFeedAction;

        this.errorHandler[item.id] = !isValid;
        readInputCheck = readInputCheck && isValid;
      });

      if (readInputCheck) {
        return readInputCheck;
      } else {
        this.$toast.error(this.$t("required_fields_error"));
      }
    },
  },

  watch: {
    change() {
      this.fetch();
    },
  },

  computed: {
    ...mapState("local", ["qr_id", "qrInfo", "change"]),
    domainName() {
      return this.$route.params.name;
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    colorComputed() {
      return this.color ?? this.value.sectionColor.text;
    },
  },
};
</script>

<style></style>
